import { OutlineColor, PlannerEcsSystem } from '@inter-ikea-storageone/range';
import { ComponentIds, HierarchyUtils, SelectableComponent } from '@inter-ikea-core/core';
import { OutlinedComponent } from '@inter-ikea-core/core';
import PlatsaUncoupledSlidingDoorComponent from '../components/PlatsaUncoupledSlidingDoorComponent';
/**
 * Marks sliding doors with PlatsaUncoupledSlidingDoorComponent red
 */
export class PlatsaUncoupledSlidingDoorSystem extends PlannerEcsSystem {
    constructor(coreApi) {
        super(coreApi, 'PlatsaUncoupledSlidingDoorSystem', PlatsaUncoupledSlidingDoorComponent.id);
        this.selectableEntities = [];
    }
    onAdd(entity) {
        this.coreApi.scene?.setGlobalOutlineColor(OutlineColor.RED);
        entity.addComponent(new OutlinedComponent());
        const frame = HierarchyUtils.findWithComponentInUpwardsHierarchy(entity, ComponentIds.FRAME_COMPONENT_ID);
        [entity, frame].forEach(e => e?.removeComponent(ComponentIds.SELECTABLE_COMPONENT_ID));
        this.coreApi.scene?.disableSelectionSystem();
    }
    onUpdate() { }
    onRemove(entity) {
        this.coreApi.scene?.setGlobalOutlineColor(OutlineColor.BLUE);
        entity.removeComponent(ComponentIds.OUTLINED_COMPONENT_ID);
        const frame = HierarchyUtils.findWithComponentInUpwardsHierarchy(entity, ComponentIds.FRAME_COMPONENT_ID);
        [entity, frame].forEach(e => e?.addComponent(new SelectableComponent()));
        this.coreApi.scene?.enableSelectionSystem();
    }
}
//# sourceMappingURL=PlatsaUncoupledSlidingDoorSystem.js.map